import { render, staticRenderFns } from "./PopQnaAdd.vue?vue&type=template&id=5819d252"
import script from "./PopQnaAdd.vue?vue&type=script&lang=js"
export * from "./PopQnaAdd.vue?vue&type=script&lang=js"
import style0 from "./PopQnaAdd.vue?vue&type=style&index=0&id=5819d252&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports